<template>
  <div class="vidclawtvid">
    <!-- <sec-title Text="按问题找视频" class="text_center" /> -->
	<div class="title">
		按问题找视频
		<div class="line">
			
		</div>
	</div>
    <div class="awtfvid between">
      <div
        class="item"
        v-for="(item, index) in taglist"
        :key="index"
        :class="{ active: index == isact }"
        @mouseover="isact = index"
      >
        <div class="awticon">
          <svg-icon icon-class="real_estate" class="svgimg" />
        </div>
        <div class="name">{{item.name}}</div>
        <!-- <div class="yw">marriage and family</div> -->
        <div class="tag flex_start wrap">
          <span v-for="(chitem,chindex) in item.children" 
          :key="chindex"
          @click="chancol(chitem)"
          >{{chitem.name}}</span>
          <!-- <span>同居</span>
          <span>继承</span>
          <span>离婚财产分割</span>
          <span>婚姻效力</span> -->
        </div>
      </div>

      <!-- <div class="item">
        <div class="awticon">
          <img src="../../../assets/claim/awnicon1.png" alt="" />
        </div>
        <div class="name">交通事故</div>
      </div>
      <div class="item">
        <div><img src="../../../assets/claim/awnicon2.png" alt="" /></div>
        <div>劳动纠纷</div>
      </div>
      <div class="item">
        <div><img src="../../../assets/claim/awnicon3.png" alt="" /></div>
        <div>拆迁安置</div>
      </div>
      <div class="item">
        <div><img src="../../../assets/claim/awnicon4.png" alt="" /></div>
        <div>刑事辩护</div>
      </div> -->

      <!-- <div class="item text_hover_shou">
        <div><img src="../../../assets/claim/awnicon5.png" alt="" /></div>
        <div>更多视频</div>
      </div> -->
    </div>
  </div>
</template>

<script>
import secTitle from "../../home/components/secTitle";
export default {
  components: { secTitle },
  data: () => ({
    isact: 0,
    taglist: [],
  }),
  beforeMount() {
    this.getproblem();
  },
  methods: {
    getproblem() {
      this.$http.fdlaw.getIndustryIfy({
        limit:6,
      }).then((res) => {
        this.taglist = res.data.map(item => {
          item.children?item.children= item.children.slice(0,6):''
          return item
        });
        console.log('res.data',res.data);
      });
    },
    chancol(item){
      this.$store.commit('laws/upvicolId',item.id)
    }
  },
};
</script>

<style lang="scss" scope>
.vidclawtvid {
  width: 1200px;
  margin: 0 auto;
  padding: 50px 0 100px;
  .title{
  	position: relative;
  	width: 246px;
  	text-align: center;
  	height: 37px;
  	font-size: 38px;
  	font-family: Source Han Sans CN;
  	font-weight: 500;
  	color: #333333;
  	line-height: 30px;
  	margin:  0 auto;
  	margin-bottom: 50px;
  	.line{
  		position: absolute;
  		top: 50px;
  		margin-left: -35px;
  		left: 50%;
  		width: 70px;
  		height: 4px;
  		background: #0465EA;
  	}
  }
  
  .awtfvid {
    width: 100%;
    height: 169px;
    margin-top: 135px;
    background: #ffffff;
    border: 1px solid #ececec;
    // border: 1px solid red;

    .item {
      width: 200px;
      text-align: center;
      position: relative;
      .awticon {
        .svgimg {
          font-size: 50px;
          color: #2a7cec;
          margin-bottom: 20px;
        }
      }
      .name {
        font-size: 20px;
        color: #323232;
      }
      .yw {
        display: none;
      }
      .tag {
        display: none;
      }

      &.active {
        text-align: center;
        width: 200px;
        height: 300px;
        background: #ffffff;
        box-shadow: 0px 0px 21px 0px rgba(217, 217, 217, 0.75);
        position: relative;
        padding-top: 75px;
        .awticon {
          display: block;
          width: 90px;
          height: 90px;
          border-radius: 50%;
          background-color: #2a7cec;
          display: flex;
          justify-content: center;
          align-items: center;
          position: absolute;
          top: -40px;
          left: 50%;
          transform: translateX(-50%);
          .svgimg {
            color: #fff;
            margin: 0;
          }
        }
        .yw {
          display: block;
          text-transform: uppercase;
          font-size: 14px;
          color: #c8c8c8;
          position: relative;
          margin: 9px 0;
          &::after {
            position: absolute;
            bottom: -9px;
            left: 50%;
            transform: translateX(-50%);
            background-color: #0465ea;
            content: "";
            width: 54px;
            height: 2px;
          }
        }
        .tag {
          margin-top: 18px;
          display: flex;
          padding: 0 10px;
          span {
            cursor: pointer;
            margin: 5px 2px;
            padding: 0 9px;
            border-radius: 30px;
            border: 1px solid #656565;
            font-size: 14px;
            color: #333333;
            &:hover {
              border: 1px solid #0465ea;
              color: #0465ea;
            }
          }
        }

        &::after {
          display: none;
        }
      }
      &::after {
        content: "";
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        background-color: #ececec;
        right: 0;
        width: 1px;
        height: 36px;
      }
      &:last-child {
        &::after {
          display: none;
        }
      }
    }
  }
}


</style>